import { render } from "./PrivacyDesc.vue?vue&type=template&id=0a1417f2&scoped=true"
import script from "./PrivacyDesc.vue?vue&type=script&lang=js"
export * from "./PrivacyDesc.vue?vue&type=script&lang=js"

import "./PrivacyDesc.vue?vue&type=style&index=0&id=0a1417f2&scoped=true&lan=scss&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1417f2"]])

export default __exports__